import React from "react";

export default function ColorFrame5({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          d="M188.708 263.649C188.708 271.25 170 276 140.954 276C119.292 276 93.2 272.2 93.2 264.599C93.2 256.998 100.155 240.372 138.492 240.372C176.829 240.372 188.708 256.048 188.708 263.649Z"
          fill="#8859C2"
        />
        <path
          d="M170.962 250.348V250.348C170.962 250.361 170.962 250.498 170.709 250.777C170.448 251.066 169.991 251.417 169.278 251.799C167.855 252.56 165.697 253.291 162.902 253.923C157.338 255.182 149.577 255.973 140.954 255.973C132.33 255.973 124.57 255.182 119.005 253.923C116.211 253.291 114.053 252.56 112.629 251.799C111.917 251.417 111.46 251.066 111.199 250.777C110.946 250.498 110.946 250.361 110.946 250.348V250.348V250.348C110.946 250.334 110.946 250.197 111.199 249.918C111.46 249.629 111.917 249.278 112.629 248.897C114.053 248.136 116.211 247.404 119.005 246.772C124.57 245.514 132.33 244.722 140.954 244.722C149.577 244.722 157.338 245.514 162.902 246.772C165.697 247.404 167.855 248.136 169.278 248.897C169.991 249.278 170.448 249.629 170.709 249.918C170.962 250.197 170.962 250.334 170.962 250.348V250.348Z"
          fill="#8859C2"
          stroke="#AA80F9"
          strokeWidth="3"
        />
        <path
          d="M170.962 243.697V243.697C170.962 243.71 170.962 243.848 170.709 244.127C170.448 244.416 169.991 244.767 169.278 245.148C167.855 245.909 165.697 246.641 162.902 247.273C157.338 248.531 149.577 249.323 140.954 249.323C132.33 249.323 124.57 248.531 119.005 247.273C116.211 246.641 114.053 245.909 112.629 245.148C111.917 244.767 111.46 244.416 111.199 244.127C110.946 243.848 110.946 243.71 110.946 243.697V243.697V243.697C110.946 243.684 110.946 243.546 111.199 243.267C111.46 242.978 111.917 242.627 112.629 242.246C114.053 241.485 116.211 240.753 119.005 240.122C124.57 238.863 132.33 238.071 140.954 238.071C149.577 238.071 157.338 238.863 162.902 240.122C165.697 240.753 167.855 241.485 169.278 242.246C169.991 242.627 170.448 242.978 170.709 243.267C170.962 243.546 170.962 243.684 170.962 243.697V243.697Z"
          fill="#8859C2"
          stroke="#AA80F9"
          strokeWidth="3"
        />
        <path
          d="M170.962 237.046V237.047C170.962 237.06 170.962 237.197 170.709 237.476C170.448 237.765 169.991 238.116 169.278 238.497C167.855 239.258 165.697 239.99 162.902 240.622C157.338 241.88 149.577 242.672 140.954 242.672C132.33 242.672 124.57 241.88 119.005 240.622C116.211 239.99 114.053 239.258 112.629 238.497C111.917 238.116 111.46 237.765 111.199 237.476C110.946 237.197 110.946 237.06 110.946 237.047V237.046V237.046C110.946 237.033 110.946 236.896 111.199 236.617C111.46 236.328 111.917 235.977 112.629 235.596C114.053 234.835 116.211 234.103 119.005 233.471C124.57 232.213 132.33 231.421 140.954 231.421C149.577 231.421 157.338 232.213 162.902 233.471C165.697 234.103 167.855 234.835 169.278 235.596C169.991 235.977 170.448 236.328 170.709 236.617C170.962 236.896 170.962 237.033 170.962 237.046V237.046Z"
          fill="#8859C2"
          stroke="#AA80F9"
          strokeWidth="3"
        />
        <path
          d="M10.9949 100.339C3.46452 45.3896 39.6261 -0.762227 87.4756 0.00954148C135.325 0.78131 152.974 17.7602 152.974 17.7602C164.61 92.8789 178.012 248.161 143.811 249.396C101.061 250.939 88.1458 211.517 80.3016 202.256C72.4574 192.994 20.4079 169.027 10.9949 100.339Z"
          fill="url(#paint0_linear_2087_157125)"
        />
        <path
          d="M265.003 100.34C272.549 45.3899 236.311 -0.762232 188.36 0.00954155C140.41 0.781316 122.723 17.7603 122.723 17.7603C111.063 92.8796 104.712 248.163 138.985 249.398C181.826 250.941 193.601 210.36 201.462 201.099C209.322 191.838 255.57 169.028 265.003 100.34Z"
          fill="url(#paint1_linear_2087_157125)"
        />
        <path
          d="M137 229.921H145.8"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M163.017 191.453C169.7 184.095 181.071 177.734 186.888 176.702C191.735 175.841 195.886 175.651 197.118 180.869C198.659 187.391 190.191 204.374 177.899 208.444C165.607 212.514 148.352 207.598 163.017 191.453Z"
          fill="black"
        />
        <path
          d="M119.316 191.453C112.633 184.095 101.262 177.734 95.4453 176.702C90.598 175.841 86.4473 175.651 85.2148 180.869C83.6742 187.391 92.1425 204.374 104.434 208.444C116.726 212.514 133.982 207.598 119.316 191.453Z"
          fill="black"
        />
        <ellipse
          cx="143.908"
          cy="211.394"
          rx="0.984615"
          ry="7.12565"
          fill="black"
        />
        <ellipse
          cx="138"
          cy="211.394"
          rx="0.984615"
          ry="7.12565"
          fill="black"
        />
        <path
          d="M138 175.5C182.366 175.5 218.5 140.894 218.5 98C218.5 55.1064 182.366 20.5 138 20.5C93.6344 20.5 57.5 55.1064 57.5 98C57.5 140.894 93.6344 175.5 138 175.5Z"
          fill="white"
          stroke="#B8E33D"
          strokeWidth="5"
        />
        <circle cx="175" cy="191" r="4" fill="white" />
        <circle cx="106" cy="191" r="4" fill="white" />
        <defs>
          <linearGradient
            id="paint0_linear_2087_157125"
            x1="138"
            y1="0"
            x2="141"
            y2="375"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.293269" stopColor="#D6FF62" />
            <stop offset="1" stopColor="#B9E242" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2087_157125"
            x1="138"
            y1="0"
            x2="141"
            y2="375"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.293269" stopColor="#D6FF62" />
            <stop offset="1" stopColor="#B9E242" />
          </linearGradient>
        </defs>
        {children}
      </g>
    </svg>
  );
}
